<template>
  <div>
    <div class="">
      <v-text-field
        light
        label="Title"
        v-model="item.name"
        type="text"
        required
        color="amber"
        placeholder="Name"
      ></v-text-field>
      <v-textarea
        light
        label="Notes"
        color="amber"
        v-model.trim="item.body"
        :rows="2"
        :autoGrow="true"
        :hide-details="true"
      />
    </div>
    <div>
      <v-switch
        light
        :items="colors"
        label="Does this require a logo?"
        v-model="item.logo"
        class="mt-8"
        color="amber"
      ></v-switch>
    </div>
    <div class="">
      <v-select
        light
        :items="colors"
        label="Colour code"
        :value="item.color"
        v-model.trim="item.color"
        item-text="title"
        item-value="color"
        class="mr-4 mt-8"
      ></v-select>
      <v-textarea
        v-if="item.color"
        label="Label text"
        color="green"
        class="black--text"
        v-model="item.label"
        :rows="1"
        :autoGrow="true"
        :hide-details="false"
        required
        placeholder="Enter a number of letter"
        light
      />

      <v-select
        :items="audiences"
        label="Audiences"
        multiple
        v-model.trim="item.audiences"
        light
      ></v-select>
    </div>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="mr-2" light
        >Change</v-btn
      >
      <v-btn @click="cancel" small color="grey" class="" light>Cancel</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "EcoSystemForm",
  props: {
    newItem: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Array,
      default: () => [],
    },
    audiences: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      item: this.newItem,
    };
  },
  methods: {
    submit() {
      this.$emit("submit", this.item);
      this.$set(this.item, {});
    },
    cancel() {
      this.$emit("cancel", this.item);
      this.$set(this.item, {});
    },
  },
};
</script>
